<template>
	<div class="container">
		<div class="w-100 flex-column flex-lg-row d-flex mt-5 mb-4">
			<div class="col-12 col-lg-8 order-last order-lg-first">
				<h3 class="bold mb-4">{{currentCategory?.name}}</h3>
				<h5 v-html="currentCategory?.summary || currentCategory?.description"></h5>
			</div>

			<div class="col-12 col-lg-4 mb-4 order-first order-lg-last d-flex align-items-center justify-content-center">
				<img :src="currentCategory?.image" alt="" class="category-image-width rounded-4">
			</div>

		</div>
		<section class="products-section pb-5 mb-3">
			<div class="h-100">
				<div class="w-100 text-center pt-4">
					<h4 class="section-title">{{ $t('browse-current-category-products') }}</h4>
				</div>

				<!-- tabs -->
				<div class="d-flex flex-wrap justify-content-center mx-auto my-5">
					<ul v-for="item in categories" :key="item.id" class="nav nav-pills mb-3" id="pills-tab" role="tablist">
						<li class="nav-item" role="presentation">
							<button
								:class="{'active': activeCategory === item.slug}"
								class="nav-link"
								type="button"
								role="tab"
								@click="$router.push({name: 'category', params: {slug: item.slug}})"
							>
								{{item.name}}
							</button>
						</li>
					</ul>
				</div>
				<div v-if="productsLoading" class="d-flex justify-content-center">
					<div class="loader"></div>
				</div>
				<div v-else class="w-100 d-flex flex-wrap">
					<router-link
						v-for="item in pageProducts"
						:key="item.id"
						class="product-card-block mb-4 router-link-class"
						:to="{ name: 'product', params: { slug: item.slug } }"
					>
						<div class="px-4 pt-4 pb-3 rounded-top-4 bg-white card-shadow card-content-height">
							<!-- content -->
							<div class="d-flex flex-column justify-content-between text-center h-100">
								<div class="product-image pb-2">
									<img :src="item?.primaryImage.url" alt="" class="rounded-3" width="fit-content" height="100%">
								</div>
								<div class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
									<div class="product-name bold h-100 d-flex align-items-center">
										{{item.name}}
									</div>
									<div class="product-attributes pt-2 d-flex justify-content-center">
										<div class="d-flex">
											<div v-if="item.attributes.some(c => c.type === 13)" class="d-flex align-items-center">
												<div class="d-flex align-items-center">
													<div
														v-for="(element, i) in filterAttributeValues(item.attributes.find(c => c.type === 13))"
														:key="i"
														:style="{ backgroundColor: element, width: '10px', height: '10px', borderRadius: '50%', margin: '0px 2px', border: '1px solid grey' }"
													>
													</div>
													<div v-if="item.attributes.find(c => c.type === 13)?.values.length > 4" style="margin: 0 2px">+</div>
												</div>
											</div>
										</div>
										<span v-if="item.attributes.length > 1" class="px-2 text-center" style="color: grey">|</span>
										<div class="d-flex justify-content-center">
											<div class="v-html-content content-elipse" v-html="item.attributes.find(c => c.type !== 13)?.value"></div>
											<img v-if="item.attributes.find(c => c.type !== 13)?.image?.url" :src="item.attributes[1]?.image?.url" alt="" class="px-1" width="25">
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- eye -->
						<div class="w-100 rounded-bottom-4 text-center product-card-eye d-flex align-items-center justify-content-center">
							<i class="fa-solid fa-eye"></i>
						</div>
					</router-link>
				</div>
				<div class="w-100 mt-5 pt-2">
					<router-link to="/all-products" class="tall-button first-button mx-auto mx-auto text-decoration-none">
						<span class="px-1 bold">
							{{ $t('homepage.products-section.button') }}
						</span>
					</router-link>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { filterAttributeValues } from '@/helpers/functions';
export default {
	name: 'CategoryPage',
	data () {
		return {
			activeCategory: null,
			productsLoading: false,
			tabs: [
				{
					id: 1,
					name: 'براغي خشبية'
				},
				{
					id: 2,
					name: 'براغي PVC'
				},
				{
					id: 3,
					name: 'براغي حديد'
				}
			],
			productsTest: [
				{
					id: 1,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 2,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 3,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 4,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 5,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 6,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 7,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 8,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 9,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 10,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 11,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 12,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 13,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 14,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 15,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 16,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 17,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 18,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 19,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 20,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				}
			],
		}
	},

	watch: {
		'$route' (newVal) {
			this.activeCategory = newVal.params.slug
		},
	},

	computed: {
		...mapState({
			categories: state => state.categories.categories,
			products: state => state.products.products,
		}),

		currentCategory () {
			return this.categories.find(c => c.slug === this.$route.params.slug)
		},

		pageProducts () {
			if (this.currentCategory) {
				return this.products?.filter(c => c.categoriesIds[0] === this.currentCategory?.id)
			}
			return []
		},
	},

	methods: {
		filterAttributeValues
	},

	mounted () {
		this.activeCategory = this.$route.params.slug
		if (this.products?.length === 0) {
			this.productsLoading = true
			this.$store.dispatch('products/fetchAllProducts').finally(() => {
				this.productsLoading = false
			})
		}
	}

}
</script>

<style lang="scss" scoped>
@import '../../scss/vars.scss';
// major classes
.section-title {
	font-weight: 800;
	line-height: 1.65;
}

.section-title ::v-deep span {
	color: $secondary;
	font-weight: 900;
}

.category-image-width {
	width: 175px;

	@media (max-width: 768px) {
		width: 200px;
	}
}

.products-section {
	.product-card-block {
		@media (min-width: 1600px) {
			width: 15%
		}

		width: 17%;
		margin: 0 15px;
		@media (max-width: 1200px) {
			margin: 0 14px;
		}

		@media (max-width: 992px) {
			width: 23%;
			margin: 0 6px;
		}

		@media (max-width: 768px) {
			width: 31%
		}

		@media (max-width: 568px) {
			width: 47%;
			margin: 0 5px;
		}

		@media (max-width: 375px) {
			margin: 0 auto;
		}

		@media (max-width: 359px) {
			width: 94%;
		}

		.product-image {
			height: 125px;
		}

		.product-name {
			font-size: 14px;
		}

		.product-attributes {
			font-size: 13px;
		}

		.card-content-height {
			height: 87.5%
		}

		transition: transform 0.15s ease, box-shadow 0.15s ease;
		&:hover {
			transform: translateY(-3px);
		}
	}

	.product-card-eye {
		background-color: $primary;
		height: 30px;
		color: white;
	}
}
.nav-link {
	color: rgb(39, 43, 104);
	font-weight: bold;
	border-radius: 0;
}
.nav-link.active {
	background-color: transparent;
	color: $secondary;
	border-bottom: 1px solid $secondary;
}

.nav-pills {
	@media (max-width: 475px) {
		padding: 0
	}
}
</style>

<style labg="scss" scoped>
.content-elipse {
	font-size: 12px;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>